import React, { FunctionComponent } from "react";

interface WineGlassIconProps {
  color?: string;
  size?: string;
}

const WineGlassIcon: FunctionComponent<WineGlassIconProps> = ({
  color = "#EC4747",
  size = "40",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 31.6667V23.1483L5.64175 9.0464C5.2286 8.58734 5 7.9916 5 7.374V7C5 5.89543 5.89543 5 7 5H33C34.1046 5 35 5.89543 35 7V7.374C35 7.9916 34.7714 8.58734 34.3582 9.0464L21.6667 23.1483V31.6667H28.3333C29.2538 31.6667 30 32.4129 30 33.3333C30 34.2538 29.2538 35 28.3333 35H11.6667C10.7462 35 10 34.2538 10 33.3333C10 32.4129 10.7462 31.6667 11.6667 31.6667H18.3333ZM12.4833 11.6667H27.5167L30.1412 8.75057C30.2859 8.58969 30.1718 8.33333 29.9553 8.33333H10.0447C9.82823 8.33333 9.71406 8.58969 9.85885 8.75057L12.4833 11.6667Z"
        fill={color}
      />
    </svg>
  );
};

export default WineGlassIcon;
